// extracted by mini-css-extract-plugin
module.exports = {"btnAuthForm":"styles_btnAuthForm__s0_Q6"};